module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-middle-50c864311a585140c5d2a4ce7d29bb5b.png";